/* eslint-disable no-script-url */

import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { Button } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2)
  },
  pushButton: {
    marginRight: theme.spacing(2)
  }
}))

const RightSideSubmitButton: React.FC<{
  submittable: boolean
  resettable?: boolean
  submitHandler: () => void
  resetHandler?: () => void
  resetText?: string
  submitText?: string
  size?: 'small' | 'medium' | 'large'
}> = ({
  submittable,
  resettable,
  submitHandler,
  resetHandler,
  resetText = 'リセット',
  submitText = '登録',
  size = 'medium'
}) => {
  const classes = useStyles({})

  return (
    <React.Fragment>
      <div className={classes.buttonContainer}>
        {resettable && (
          <Button
            className={classes.pushButton}
            variant="contained"
            color="primary"
            onClick={resetHandler}
            size={size}
          >
            {resetText}
          </Button>
        )}
        <Button
          type="submit"
          disabled={!submittable}
          className={classes.pushButton}
          variant="contained"
          color="primary"
          onClick={submitHandler}
          size={size}
        >
          {submitText}
        </Button>
      </div>
    </React.Fragment>
  )
}

export default RightSideSubmitButton
